<template>
  <FlyerlineModal ref="modalRef" name="sorten-verteilung-table" class="config-modal">
    <div class="bg-shade-light">
      <div class="bg-transparent config-group-outline px-prj2 py-prj px-3@large border mt-prj3 flex flex-column gap-4">
        <div class="d-flex mt-2 p-2 bg-secondary text-white text-small line-height-12"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="fill-secondary mr-2 svg-icon flex-child-fix position-relative t-1px"><circle cx="18" cy="18" r="18" fill="#fff"></circle><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#e94d47"></path></svg>
          <p>{{'txtUploadFiles'|translate(globalConfig.shop.currency)}}</p>
        </div>
        <table class="w-full table--bordered" style="grid-template-columns: repeat(4, 1fr);">
          <thead>
          <tr>
            <th class="bg-shade-light"></th>
            <th>{{'txtSortenDescription'|translate}}</th>
            <th>{{'txtSortenQuantity'|translate}} ({{ numAuflagen }} {{'txtPieces'|translate}})</th>
            <th>{{'txtUploadPrintFile'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="[index, sorte] in sortenData.entries()">
            <td class="bg-shade-light">
              {{'txtVariant'|translate}} {{ index + 1 }}
            </td>
            <td>
              <input ref="sortenVariantIdentifierRefs" type="string" @input="updateSortenEntry(index)" :value="sortenData[index]?.variantIdentifier ? sortenData[index]?.variantIdentifier : ''" />
            </td>
            <td>
              <input ref="sortenAmountRefs" class="text-center" type="number" @input="updateSortenEntry(index)" :value="sortenData[index]?.num ? sortenData[index]?.num : 0" />
            </td>
            <td>
              <SkyUploadWrapper v-show="!sorte.fileName" @fileUploadProgressStateChanged="fileUploadProgressStateChanged(index, $event)" @fileschanged="filesChanged(index)" @uploadFinished="fileUploaded(index, $event)" ref="sortenFileUploadRef" :fileuploadid="'sorte-upload-'+index" :upload-file-extensions="globalConfig.uploadFileExtensions"
                                :multiple="false" :inline="true" :expanded="true" />
              <div v-if="sorte.fileName" class="file-list">
                <div class="small-12 column">
                  <PrintFile compact="true" :filename="sorte.fileName" :fileid="sorte.fileIdentifier" :filestatus="sorte.isFileFieldValid === undefined || sorte.isFileFieldValid ? FILESTATUS.OK : FILESTATUS.ERROR_FILETYPE"
                             :file="null" :url="null" v-on:delete-file="deleteFile(index)"/>
                </div>
              </div>
            </td>
            <td class="spanned" v-if="pristine === false && ((sorte?.isTitleFieldValid === false && !!sorte?.titleFieldMessage) || (sorte?.isFileFieldValid === false && !!sorte?.fileFieldMessage))">
              <div v-if="!!sorte?.titleFieldMessage" class="py-1 px-2 bg-error text-white w-100 text-small">
                <ul>
                  <li>{{ sorte?.titleFieldMessage }}</li>
                </ul>
              </div>
              <div v-if="!!sorte?.fileFieldMessage" class="py-1 px-2 bg-error text-white w-100 text-small">
                <ul>
                  <li>{{ sorte?.fileFieldMessage }}</li>
                </ul>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td class="bg-shade-light">{{'txtTotal'|translate}}</td>
            <td></td>
            <td>{{ totalAmount }} {{'txtPieces'|translate}}</td>
            <td>
              <button class="btn w-100" :disabled="uploadInProgress || (!pristine && !isValid)" @click="save()">{{'txtSave'|translate}}</button>
            </td>
          </tr>
          <tr>
            <td class="bg-shade-light">{{'txtVersandaufteilungRemainingPieces'|translate}}</td>
            <td></td>
            <td :class="{'error': remainingAmount < 0}">{{ remainingAmount }} {{'txtPieces'|translate}}</td>
            <td>
            </td>
          </tr>
          <tr v-if="pristine === false && !!overallMessage">
            <td class="spanned">
              <div class="py-1 px-2 error text-small">
                <ul>
                  <li>{{overallMessage}}</li>
                </ul>
              </div>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </FlyerlineModal>
</template>

<script>
import FlyerlineModal from "../../fragments/FlyerlineModal.vue";
import SkyUploadWrapper from "../../fragments/SkyUploadWrapper.vue";
import PrintFile, {FILESTATUS} from "../PrintFile.vue";

export default {
  components: {PrintFile, SkyUploadWrapper, FlyerlineModal},
  inject: ['globalConfig','sortenVerteilungService', 'configuratorService'],
  props: {
    option: {
      default: {}
    }
  },
  data() {
    return {
      totalAmount: 0,
      remainingAmount: this.numAuflagen,
      uploadInProgress: false,
      numAuflagen: 0,
      sortenData: [],
      sortTotalAmount: 0,
      inputDebounce: undefined,
      overallMessage: '',
      isValid: true,
      pristine: true,
      FILESTATUS: FILESTATUS
    }
  },
  methods: {
    updateSortenEntry(index) {
      clearTimeout(this.inputDebounce);
      this.inputDebounce = setTimeout(() => {
        this.sortenData[index] = {
          ...(this.sortenData[index] ?? {}),
          variantIdentifier: this.$refs.sortenVariantIdentifierRefs[index]?.value ?? "",
          num: this.$refs.sortenAmountRefs[index]?.valueAsNumber || 0
        }

        this.totalAmount = this.$refs.sortenAmountRefs.reduce((acc, curr) => {
          if(isNaN(curr.valueAsNumber)) {
            return acc
          }
          return acc + curr.valueAsNumber
        }, 0) || 0;

        const sanitizedSortenData = this.sortenData.filter(Boolean);

        this.validate(sanitizedSortenData, this.numAuflagen);
      }, 500)
    },
    fileUploadProgressStateChanged(index, isLoading) {
      this.uploadInProgress = isLoading
    },
    filesChanged(index) {
      this.$refs.sortenFileUploadRef[index].startUpload();
    },
    deleteFile(index) {
      const fileIdentifier = "";
      const fileName = "";
      this.sortenData[index] = {
        ...this.sortenData[index] ?? [],
        fileIdentifier,
        fileName
      }

      const sanitizedSortenData = this.sortenData.filter(Boolean);

      this.validate(sanitizedSortenData, this.numAuflagen);
    },
    fileUploaded(index, data) {
      const fileIdentifier = data.identifier;
      const fileName = data.filenames;
      this.sortenData[index] = {
        ...this.sortenData[index] ?? [],
        fileIdentifier,
        fileName
      }

      const sanitizedSortenData = this.sortenData.filter(Boolean);

      this.validate(sanitizedSortenData, this.numAuflagen);
    },
    open() {
      this.pristine = true;
      this.numAuflagen = this.configuratorService.numAuflagen;
      this.sortenData = this.prepareSortenData() ;

      this.$refs.modalRef.open();
    },
    prepareSortenData() {
      const sortenData = [];

      for(let i=0; i<this.option.dynamicValues.numSorten; i++) {
        sortenData.push({
          title: `${window?.dict_prj.get("txtVariant")} ${i}`
        })
      }

      const storedSortenData = structuredClone(this.option.dynamicValues.sortenFiles);

      storedSortenData?.forEach((storedSorte, index) => {
        sortenData[index] = storedSorte
      });

      return sortenData.length > 1 ? sortenData : [{
        title: `${window?.dict_prj.get("txtVariant")} 1`
      }];
    },
    close() {
      this.$refs.modalRef.close();
    },
    validate(sortenData, numAuflagen) {
      return this.sortenVerteilungService.validate(sortenData, numAuflagen).then((data) => {
        this.overallMessage = data.message;

        data.sorten.forEach((sortenResponse, index) => {
          const originalSortenData = [...this.sortenData];
          originalSortenData[index] = {
            ...originalSortenData[index],
            isTitleFieldValid: sortenResponse['title_validation'].valid,
            titleFieldMessage: sortenResponse['title_validation'].msg,
            isFileFieldValid: sortenResponse['file_validation'].valid,
            fileFieldMessage: sortenResponse['file_validation'].msg,
          }

          this.sortenData = [
            ...originalSortenData
          ];
        })

        const sortenTitleFieldsAreAllValid = data.sorten.every((sortenResponse) => sortenResponse['title_validation'].valid === true)
        const sortenFileFieldsAreAllValid = data.sorten.every((sortenResponse) => sortenResponse['file_validation'].valid === true)
        const sortenFieldsAreAllValid = sortenTitleFieldsAreAllValid && sortenFileFieldsAreAllValid;

        this.isValid = data.valid && sortenFieldsAreAllValid;
        this.remainingAmount = data['number_remaining'];
      })
    },
    save() {
      this.pristine = false;

      this.validate(this.sortenData, this.numAuflagen).then(() => {
        if(this.isValid) {
          const sortenFiles = this.sortenData.map((sorte) => ({
            num: sorte.num,
            variantIdentifier: sorte.variantIdentifier,
            fileIdentifier: sorte.fileIdentifier,
            fileName: sorte.fileName,
            status: 1
          }));

          this.configuratorService.sortenFiles = sortenFiles;
          this.option.dynamicValues.numAuflagen = this.numAuflagen;
          this.option.dynamicValues.sortenFiles = sortenFiles;
          this.close();
          this.$emit("saved");
        }
      })
    }
  }
}
</script>